<template>
  <div class="login-container">
    <div class="mascara row">
      <div
        class="col-lg-6 col-md-8 col-sm-7 row inline absolute-center bg-login"
      >
        <div class="col-12 row">
          <transition
            appear
            enter-active-class="animated slideInRight"
            leave-active-class="animated slideOutRight"
          >
            <section
              v-if="show"
              key="login-atualizacoes"
              class="col-12 row inline"
            >
              <login-title />
              <login-form />
            </section>
          </transition>
        </div>
      </div>
      <div class="absolute-bottom text-center q-mb-md">
        <img src="~assets/logoVeolia.png" class="veolia-logo" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { messageBox } from 'jtech'
import {
  loginForm,
  loginTitle
} from './index.js'

@Component({
  name: 'login',
  components: {
    loginForm,
    loginTitle
  }
})
export default class Login extends Vue {
  show = true;
  beforeMount () {
    if (this.$route.params.reload) {
      const parser = new URL(window.location)
      parser.searchParams.set('expired', this.$route.params.expired)
      window.location = parser.href
    }
  }

  mounted () {
    if (this.$route.query?.expired == 'true') {
      messageBox.warn(this.$gettext('SESSION_EXPIRED'))
    }
    const url = new URL(location)
    url.searchParams.delete('expired')
    history.replaceState(null, null, url)
  }
}
</script>
<style lang="stylus" scoped>
.login-container {
  width: 100%;
  background-image: url("~assets/backgroundLogin.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: calc(100vh - 0px);
  overflow-y: auto;
}

.mascara {
  width: 100%;
  height: 100%;
  background: rgba(57, 64, 83, 0.8);
}

.veolia-logo{
  width: 9%;
  opacity: 0.8;
}

@media only screen and (max-width: 1600px) {
  .bg-login {
    min-width: 55%!important;
  }
}
</style>
